import EmblaCarousel from "embla-carousel";
import Autoplay from "embla-carousel-autoplay";

function setupButtons(embla, root) {
  const prevBtn = root.querySelector("[data-embla-prev]");
  const nextBtn = root.querySelector("[data-embla-next]");

  const updateButtons = () => {
    const canPrev = embla.canScrollPrev();
    const canNext = embla.canScrollNext();
    // Hide the arrows entirely when there is nothing to scroll (e.g. a single
    // slide, or all slides already fit). Uses the `hidden` utility class so it
    // wins over the button's `inline-flex` component style.
    const scrollable = canPrev || canNext;

    if (prevBtn) {
      prevBtn.disabled = !canPrev;
      prevBtn.classList.toggle("hidden", !scrollable);
    }
    if (nextBtn) {
      nextBtn.disabled = !canNext;
      nextBtn.classList.toggle("hidden", !scrollable);
    }
  };

  if (prevBtn) prevBtn.addEventListener("click", () => embla.scrollPrev());
  if (nextBtn) nextBtn.addEventListener("click", () => embla.scrollNext());

  embla.on("select", updateButtons);
  embla.on("init", updateButtons);
  embla.on("reInit", updateButtons);
  updateButtons();
}

function setupDots(embla, root) {
  const dotsNode = root.querySelector("[data-embla-dots]");
  if (!dotsNode) return;

  let dotNodes = [];

  const renderDots = () => {
    dotsNode.innerHTML = embla
      .scrollSnapList()
      .map(
        (_, index) =>
          `<button class="embla__dot size-4 rounded-full border-2 border-base-black bg-base-white transition-colors" type="button" aria-label="Go to slide ${index + 1}"></button>`,
      )
      .join("");
    dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
    dotNodes.forEach((dot, index) =>
      dot.addEventListener("click", () => embla.scrollTo(index)),
    );
  };

  const updateDots = () => {
    const selected = embla.selectedScrollSnap();
    dotNodes.forEach((dot, index) => {
      dot.classList.toggle("bg-brand-500", index === selected);
      dot.classList.toggle("border-brand-500", index === selected);
      dot.classList.toggle("bg-base-white", index !== selected);
      dot.classList.toggle("border-base-black", index !== selected);
    });
  };

  embla.on("init", () => {
    renderDots();
    updateDots();
  });
  embla.on("reInit", () => {
    renderDots();
    updateDots();
  });
  embla.on("select", updateDots);

  renderDots();
  updateDots();
}

export function initEmblaCarousel(root) {
  if (root.dataset.emblaInit) return;
  root.dataset.emblaInit = "true";

  const viewport = root.querySelector(".embla__viewport");
  if (!viewport) return;

  const autoplayDelay = parseInt(root.dataset.emblaAutoplay, 10);
  const plugins = autoplayDelay
    ? [
        Autoplay({
          delay: autoplayDelay,
          stopOnInteraction: false,
          stopOnMouseEnter: true,
        }),
      ]
    : [];

  const embla = EmblaCarousel(
    viewport,
    {
      loop: false,
      slidesToScroll: "auto",
    },
    plugins,
  );

  setupButtons(embla, root);
  setupDots(embla, root);
}

export function initEmblaCarouselGallery(root) {
  if (root.dataset.emblaInit) return;
  root.dataset.emblaInit = "true";

  const viewport = root.querySelector(".embla__viewport");
  if (!viewport) return;

  const embla = EmblaCarousel(viewport, {
    slidesToScroll: "auto",
  });

  setupButtons(embla, root);
}
